import BrandProfilePanel from './BrandProfilePanel'

export default BrandProfilePanel
